import React from 'react';

import { secureRequest } from 'utils/request';
import { useHistory } from 'react-router';
import { ErrorPage } from '../components/ErrorPage';

export const NoConnection: React.FC = () => {
  const history = useHistory();

  const handleClickRefresh = async () => {
    const result = await secureRequest('/api/v1/auth/current');
    if (result) {
      history.push('/');
    }
  };

  return (
    <ErrorPage
      title="Нет соединения"
      actionButtonText="Обновить"
      actionCallback={handleClickRefresh}
    >
      <p>Проверьте интернет-подключение</p>
      <p>и</p>
      <p>обновите страницу</p>
    </ErrorPage>
  );
};
